<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <div class="flex align-center justify-end header-search-box">
            <el-input
              placeholder="查询条件"
              clearable
              v-model="searchInput"
              class="header-search-input ml10"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="textblue searchBtn"
                @click="search()"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <!-- <el-scrollbar style="height: 100%; width: 100%"> -->
        <el-row>
          <el-table
            :data="tableData"
            border
            fit
            highlight-current-row
            style="width: 100%"
            @sort-change="sortChange"
          >
            <el-table-column
              label="序号"
              align="center"
              type="index"
            ></el-table-column>
            <!-- <el-table-column label="商家编码" align="center"  prop="商家编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="商家名称" align="center"  prop="商家名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantName }}</span>
                        </template>
                    </el-table-column> -->
            <!-- <el-table-column label="活动编码" align="center"  prop="活动编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.planCode }}</span>
                        </template>
                    </el-table-column> -->
            <el-table-column label="活动名称" align="center" prop="活动名称">
              <template slot-scope="scope">
                <span>{{ scope.row.planName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="活动类型" align="center" prop="活动类型">
              <template slot-scope="scope">
                <span>
                  {{
                    scope.row.planType == "1"
                      ? "整单折扣"
                      : scope.row.planType == "2"
                      ? "分类折扣"
                      : scope.row.planType == "3"
                      ? "菜品折扣"
                      : scope.row.planType == "4"
                      ? "特价菜"
                      : scope.row.planType == "5"
                      ? "第N份优惠"
                      : scope.row.planType == "6"
                      ? "买赠"
                      : scope.row.planType == "7"
                      ? "买免"
                      : scope.row.planType == "8"
                      ? "菜品加价购"
                      : scope.row.planType == "9"
                      ? "满量折扣"
                      : scope.row.planType == "10"
                      ? "满量免减"
                      : scope.row.planType == "11"
                      ? "满量一口价"
                      : scope.row.planType == "12"
                      ? "满量菜品特价"
                      : scope.row.planType == "13"
                      ? "满减/每满减"
                      : scope.row.planType == "14"
                      ? "满赠/每满赠"
                      : scope.row.planType == "15"
                      ? "满额/每满额加价"
                      : scope.row.planType == "16"
                      ? "满折"
                      : scope.row.planType == "17"
                      ? "满额/每满额优惠购"
                      : "-"
                  }}</span
                >
              </template>
            </el-table-column>
            <!-- <el-table-column label="展示名称" align="center"  prop="展示名称" width="130px">
                        <template slot-scope="scope">
                            <span>{{ scope.row.showName }}</span>
                        </template>
                    </el-table-column> -->
            <!-- <el-table-column label="活动渠道" align="center"  prop="活动渠道" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.planChannel }}</span>
                        </template>
                    </el-table-column> -->
            <el-table-column
              label="活动时间"
              align="center"
              prop="活动日期类型"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.planDateType == 1">永久有效</span>
                <span v-else>
                  {{ scope.row.startDate }} - {{ scope.row.endDate }}</span
                >
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center" prop="状态">
              <template slot-scope="scope">
                <!-- <span>{{
                  scope.row.status == "1"
                    ? "进行中"
                    : scope.row.status == "2"
                    ? "终止"
                    : scope.row.status == "3"
                    ? "已过期"
                    : "-"
                }}</span> -->
                <span v-if="scope.row.status == '0'">未开始</span>
                <span v-if="scope.row.status == '1'">进行中</span>
                <span v-if="scope.row.status == '2'">已停止</span>
                <span v-if="scope.row.status == '3'">已过期</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="折扣率" align="center"  prop="折扣率" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.rate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="适用菜品类型" align="center"  prop="适用菜品类型" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.useDishType }}</span>
                        </template>
                    </el-table-column> -->
            <el-table-column
              label="活动说明"
              align="center"
              prop="活动说明"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span>{{ scope.row.description }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="活动星期" align="center"  prop="活动星期" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.planWeek }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="每单是否限购" align="center"  prop="每单是否限购" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderIsLimit }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="每单限购几份" align="center"  prop="每单限购几份" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderLimitNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="同一菜品限购" align="center"  prop="同一菜品限购" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.sameProductIsLimit }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="同一菜品限购几份" align="center"  prop="同一菜品限购几份" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.sameProductLimitNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="折扣规则" align="center"  prop="折扣规则" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.discountRule }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="优惠方式" align="center"  prop="优惠方式" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.discountMethod }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="每购买N份" align="center"  prop="每购买N份" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.buyNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="其中一份享受多少优惠" align="center"  prop="其中一份享受多少优惠" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.buyRate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="其中一份减免多少钱" align="center"  prop="其中一份减免多少钱" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.reductAmount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="其中一份指定多少钱" align="center"  prop="其中一份指定多少钱" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.appointAmount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="从最低价菜品享受优惠" align="center"  prop="从最低价菜品享受优惠" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.isMIniPriceProduct }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="赠送几份" align="center"  prop="赠送几份" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.giveNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="免去规则" align="center"  prop="免去规则" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.exemptType }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="加价多少钱" align="center"  prop="加价多少钱" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.addPrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="购买以下优惠菜品满N份" align="center"  prop="购买以下优惠菜品满N份" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.fullBuyNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="优惠菜品共减多少钱" align="center"  prop="优惠菜品共减多少钱" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.totalReduceAmount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="一口价" align="center"  prop="一口价" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.onePrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="售卖量" align="center"  prop="售卖量" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.saleNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="菜品按" align="center"  prop="菜品按" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.salePrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="消费菜品满/消费菜品每满" align="center"  prop="消费菜品满/消费菜品每满" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.fullAmount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="减" align="center"  prop="减" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.reduceAmount }}</span>
                        </template>
                    </el-table-column> -->
            <!-- <el-table-column label="修改时间" align="center"  prop="修改时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.updateDt }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" align="center"  prop="创建时间" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDt }}</span>
                        </template>
                    </el-table-column> -->
            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
              fixed="right"
            >
              <template slot-scope="scope">
                <div class="btnBox">
                  <!-- <div class="toolBtn" @click="toCheckDetail(scope.row)">
                    查看
                  </div> -->
                  <!-- <div class="toolBtn">复制</div> -->
                  <div class="toolBtn" @click="gotoDetail(scope.row)">编辑</div>
                  <div v-if="scope.row.status == '1'" class="toolBtn" @click="endActivity(scope.row.id)">终止</div>
                  <div class="toolBtn" @click="del(scope.row)">删除</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <!-- </el-scrollbar> -->
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    // 终止活动
    endActivity(id){
 this.$confirm('确定终止该活动吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post('merchantDiscountPlan/stopPlan',{id}).then(res=>{
            if(res.data.code==200){
           this.$notify.success({
              title: "提示",
              message: "活动已终止",
              showClose: true
            });
            this.getListData();
            }else{
              this.$message.error(res.data.message)
            }
          })
        }).catch(() => {
          console.log('')         
        });
    },
    //查看详情
    toCheckDetail(row) {
      if (row.planType == 5) {
        this.$router.push({
          path: "/nactivityDetail",
          query: { planCode: row.planCode }
        });
      }
    },
    getFormateDate(stamps) {
      if (stamps) {
        const dt = new Date(Number(stamps));
        const y = dt.getFullYear();
        const m = (dt.getMonth() + 1 + "").padStart(2, "0");
        const d = (dt.getDate() + "").padStart(2, "0");
        const hh = (dt.getHours() + "").padStart(2, "0");
        const mm = (dt.getMinutes() + "").padStart(2, "0");
        const ss = (dt.getSeconds() + "").padStart(2, "0");
        // yyyy-mm-dd hh:mm:ss
        return `${y}${m}${d}`;
      }
    },
    //条件查询
    search() {
      this.queryInfo.condition.id = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(row) {
      var that = this;
      if (row.planType == "5") {
        this.$router.push({
          path: "/nactivityCreate",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      } else if (row.planType == "6") {
        this.$router.push({
          path: "/giveActiveCreate",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      } else if (row.planType == "7") {
        this.$router.push({
          path: "/buyFreeCreate",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      } else if (row.planType == "8") {
        this.$router.push({
          path: "/additionBuy",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      } else if (row.planType == "9") {
        this.$router.push({
          path: "/packageDiscountCreate",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      } else if (row.planType == "10") {
        this.$router.push({
          path: "/fullReduction",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      } else if (row.planType == "11") {
        this.$router.push({
          path: "/packageSpecial",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      } else if (row.planType == "12") {
        this.$router.push({
          path: "/fullSpecial",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      }else if(row.planType==13){
                this.$router.push({
          path: "/fullReduce",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      }else if(row.planType==14){
       this.$router.push({
          path: "/fullFree",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      }else if(row.planType==15){
              this.$router.push({
          path: "/fullAddition",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      }else if(row.planType==16){
              this.$router.push({
          path: "/fullDiscount",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      }else if(row.planType==17){
            this.$router.push({
          path: "/fullGoodsReduce",
          query: {
            planCode: row.planCode,
            currPage: that.queryInfo.currPage,
            pageSize: that.queryInfo.pageSize
          }
        });
      }
    },

    // 删除用户
    async del(row) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        let data = {};
        data.planCode = row.planCode;
        data.merchantCode = localStorage.getItem("merchantCode");
        that.$http
          .post("/merchantDiscountPlan/delete", data)
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition = {
        merchantCode: localStorage.getItem("merchantCode")
      };
      that.$http
        .post("/merchantDiscountPlan/list", that.queryInfo)
        .then(function(response) {
          if (response.data.code == 200) {
            response.data.data.data.forEach(e => {
              if (e.planDateType == "2") {
                let start = e.startDate;
                let end = e.endDate;
                e.startDate = that.getFormateDate(start);
                e.endDate = that.getFormateDate(end);
              }
            });
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  font-size: 16rpx;
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/ .el-button--primary {
  background-color: rgb(245, 154, 35);
  border-color: rgb(245, 154, 35);
  color: #fff;
}
.fw600 {
  font-weight: 600;
}
/deep/ .el-button:focus,
.el-button:hover {
  color: rgb(245, 154, 35);
  border-color: #f5dab1;
  background-color: #fdf6ec;
}
.toolBtn {
  padding: 0 10px;
  color: rgb(245, 167, 86);
  font-size: 12px;
  text-align: center;
  position: relative;
  cursor: pointer;
}
.toolBtn::after {
  content: "|";
  color: #ddd;
  position: absolute;
  right: 0;
}
.toolBtn:nth-last-child(1)::after {
  content: "";
}
.btnBox {
  display: flex;
  flex-wrap: wrap;
}
</style>
